import { render } from "./NewsKeyword.vue?vue&type=template&id=20a372d8"
import script from "./NewsKeyword.vue?vue&type=script&lang=ts"
export * from "./NewsKeyword.vue?vue&type=script&lang=ts"

import "./NewsKeyword.vue?vue&type=style&index=0&id=20a372d8&lang=scss"
script.render = render

export default script